import { render, staticRenderFns } from "./ContactInformationFormPart.vue?vue&type=template&id=77ff254a"
import script from "./ContactInformationFormPart.vue?vue&type=script&lang=js"
export * from "./ContactInformationFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports